import { useTranslation } from 'react-i18next';
import { Badge, Group, Stack, Text } from '@mantine/core';
import type { LoadingConditions } from '@/types/sell';

// Презентация условий погрузки продавца (часы, мощность, высота ТС, способы отгрузки, прицепы/тралы/весы).
// Общий read-only рендер для просмотра оффера продажи (SaleOfferTerms) и превью сделки покупки
// (OfferPreviewPage) — чтобы форматирование не дублировалось. Обёртку (TermRow/label) даёт вызывающий.
export default function LoadingConditionsSummary({ lc }: { readonly lc: LoadingConditions }) {
  const { t } = useTranslation();
  const timeWindow = lc.startTime && lc.endTime ? `${lc.startTime}–${lc.endTime}` : null;
  const dailyRate =
    lc.dailyShippingRate?.value != null
      ? `${lc.dailyShippingRate.value} ${
          lc.dailyShippingRate.type === 'TS' ? t('app.sell.loading.wagonsPerDay') : t('app.sell.loading.tonsPerDay')
        }`
      : null;

  return (
    <Stack gap={6}>
      {timeWindow ? (
        <Text size="sm" c="gray.8">
          {t('app.sell.loading.hours')}: {timeWindow}
        </Text>
      ) : null}
      {dailyRate ? (
        <Text size="sm" c="gray.8">
          {t('app.sell.loading.capacity')}: {dailyRate}
        </Text>
      ) : null}
      {lc.maxVehicleHight != null ? (
        <Text size="sm" c="gray.8">
          {t('app.sell.loading.vehicleHeight')}: {lc.maxVehicleHight} {t('app.sell.loading.meters')}
        </Text>
      ) : null}
      <Group gap={4} wrap="wrap">
        {(lc.shipmentModes ?? []).map((mode) => (
          <Badge key={mode} variant="default" tt="none" fw={500} radius="sm" c="gray.9">
            {mode}
          </Badge>
        ))}
        {lc.trailers ? (
          <Badge variant="default" tt="none" fw={500} radius="sm" c="gray.9">
            {t('app.sell.loading.trailers')}
          </Badge>
        ) : null}
        {lc.trawls ? (
          <Badge variant="default" tt="none" fw={500} radius="sm" c="gray.9">
            {t('app.sell.loading.trawls')}
          </Badge>
        ) : null}
        {lc.scalesLength != null ? (
          <Badge variant="default" tt="none" fw={500} radius="sm" c="gray.9">
            {t('app.sell.loading.scales')}: {lc.scalesLength} {t('app.sell.loading.meters')}
          </Badge>
        ) : null}
      </Group>
    </Stack>
  );
}
